/* src/session/SessionWarningDialog.jsx - Última Modificación: 08-01-2026 */
/* -------------- único modal de expiración de sesión ------------------- */

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions,
         Typography, Button, LinearProgress, Box, Divider,
         useTheme } from '@mui/material';
import { RiShieldKeyholeLine } from 'react-icons/ri';
import { useAuth } from '../../context/AuthContext.jsx';
import useSessionManager from '../hooks/useSessionManager.js';

const WARNING_TIME = 120; // segundos

const SessionWarningDialog = () => {
  const theme = useTheme();
  const { user, logout } = useAuth();

  const {
    sessionStatus,
    remainingTime,
    renewSession,
  } = useSessionManager(!!user);

  const open = sessionStatus === 'warning';

  const progress =
    remainingTime != null
      ? Math.max((remainingTime / WARNING_TIME) * 100, 0)
      : 0;

  const isCritical = remainingTime != null && remainingTime <= 30;

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      sx={{
        zIndex: theme.zIndex.modal + 2, // 🔝 sobre TODO
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <RiShieldKeyholeLine size={22} />
          <Typography variant="h6">
            Sesión por expirar
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Por seguridad, tu sesión se cerrará automáticamente si no continúas.
        </Typography>

        <Typography
          variant="body2"
          sx={{ mb: 1, fontWeight: 500 }}
        >
          Tiempo restante: {remainingTime}s
        </Typography>

        <LinearProgress
          variant="determinate"
          value={progress}
          color={isCritical ? 'error' : 'warning'}
          sx={{
            height: 8,
            borderRadius: 6,
            mb: 2,
          }}
        />
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          justifyContent: 'space-between',
        }}
      >
        <Button
          onClick={logout}
          color="inherit"
        >
          Cerrar sesión
        </Button>

        <Button
          onClick={renewSession}
          variant="contained"
        >
          Continuar
        </Button>
      </DialogActions>

      {/* 🏷️ Marca */}
      <Divider />
      <Box
        sx={{
          py: 1,
          textAlign: 'center',
          opacity: 0.65,
        }}
      >
        <Typography variant="caption">
          ▶️ Overwatch
        </Typography>
      </Box>
    </Dialog>
  );
};

export default SessionWarningDialog;
